import { createSlice } from '@reduxjs/toolkit'

const PackageSlice = createSlice({
  name: 'PackageSlice',
  initialState: [],
  reducers: {
    addPackage(state, action) {
      // Prevent duplicates — SignalR and API callback can both fire for the same item
      if (state.some(pkg => pkg.id === action.payload.id)) return state;
      return [...state, action.payload];
    },
    setPackages(state, action) {
      return [...action.payload];
    },
    removePackage(state, action) {
      return state.filter(pkg => pkg.id !== action.payload.id);
    },
    removeProductType(state, action) {
      // Remove the placeholder entry for this product type name
      return state.filter(pkg => !(pkg.name === action.payload && pkg.isPlaceholder === true));
    },
    updatePackage(state, action) {
      return state.map(pkg => pkg.id === action.payload.id ? action.payload : pkg);
    }
  }
})

export const { addPackage, removePackage, setPackages, updatePackage, removeProductType } = PackageSlice.actions
export default PackageSlice.reducer
